/**
 * Config Loader - Loads environment-specific Amplify configuration
 *
 * Environment detection:
 * - REACT_APP_ENV is set by scripts/detectEnvironment.js based on git branch
 * - Defaults to 'dev' if not set
 * - 'prod' loads amplify.prod.json; non-dev never falls back to dev (throws)
 *
 * NOTE: API Gateway endpoint config (api.*.json) has been removed.
 * All auth calls now go through the FastAPI backend proxy (/api/auth/*),
 * so the frontend no longer needs direct API Gateway URLs.
 */

const env = process.env.REACT_APP_ENV || 'dev';

/**
 * Get Amplify config (Cognito + AppSync)
 * Used by App.js for Amplify.configure()
 */
const getAmplifyConfig = () => {
  try {
    const config = require(`../config/amplify.${env}.json`);
    console.log(`[Config] ✓ Amplify config loaded (${env})`);
    return config;
  } catch (error) {
    console.error(`[Config] ✗ Failed to load Amplify config for: ${env}`, error);
    // No fallback: a non-dev build must never silently use the dev pool
    throw new Error(`Unable to load Amplify configuration for env "${env}"`);
  }
};

export default getAmplifyConfig;
